export default {"src":"/_next/static/media/user_avatar.1566c473.svg","height":237,"width":217,"blurWidth":0,"blurHeight":0};